/**
 * @generated SignedSource<<5a4f0de2406398e660acaec518cc93af>>
 * @relayHash f5bd9b360025c2e07116b5437c5c891c
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-trade/549.0.0-2026-03-06T17:27:43.936Z/TradeFavoritesProviderQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TradeFavoritesProviderQuery$variables = {
  loadPortfolioData?: boolean | null;
  selectedItemIds?: ReadonlyArray<string | null> | null;
  shouldFillInFolder?: boolean | null;
  userIds?: ReadonlyArray<string | null> | null;
};
export type TradeFavoritesProviderQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"FolderWrapper_viewer" | "HeartWrapper_viewer">;
  };
};
export type TradeFavoritesProviderQuery = {
  response: TradeFavoritesProviderQuery$data;
  variables: TradeFavoritesProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "loadPortfolioData"
},
v1 = {
  "defaultValue": ([]/*: any*/),
  "kind": "LocalArgument",
  "name": "selectedItemIds"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "shouldFillInFolder"
},
v3 = {
  "defaultValue": ([]/*: any*/),
  "kind": "LocalArgument",
  "name": "userIds"
},
v4 = {
  "kind": "Variable",
  "name": "selectedItemIds",
  "variableName": "selectedItemIds"
},
v5 = {
  "kind": "Variable",
  "name": "userIds",
  "variableName": "userIds"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "kind": "Variable",
  "name": "itemIds",
  "variableName": "selectedItemIds"
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "serviceId",
    "storageKey": null
  },
  (v8/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Item",
  "kind": "LinkedField",
  "name": "item",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v11 = {
  "kind": "Literal",
  "name": "portfolioTypes",
  "value": [
    "HEART"
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TradeFavoritesProviderQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": [
              (v4/*: any*/),
              {
                "kind": "Variable",
                "name": "shouldFillInFolder",
                "variableName": "shouldFillInFolder"
              },
              (v5/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "FolderWrapper_viewer"
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "loadPortfolioData",
                "variableName": "loadPortfolioData"
              },
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "HeartWrapper_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "TradeFavoritesProviderQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "condition": "shouldFillInFolder",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "folderItemMatches",
                "args": [
                  (v7/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "portfolioTypes",
                    "value": [
                      "FOLDER"
                    ]
                  },
                  (v5/*: any*/)
                ],
                "concreteType": "PortfolioItemV2",
                "kind": "LinkedField",
                "name": "portfolioItemMatches",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v10/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "loadPortfolioData",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "heartItemMatches",
                "args": [
                  (v7/*: any*/),
                  (v11/*: any*/),
                  (v5/*: any*/)
                ],
                "concreteType": "PortfolioItemV2",
                "kind": "LinkedField",
                "name": "portfolioItemMatches",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "portfolioId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "portfolioItemId",
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "userPortfolios",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  },
                  (v11/*: any*/),
                  (v5/*: any*/)
                ],
                "concreteType": "PortfoliosConnection",
                "kind": "LinkedField",
                "name": "portfolios",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PortfoliosEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PortfolioV2",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v9/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-trade/549.0.0-2026-03-06T17:27:43.936Z/TradeFavoritesProviderQuery",
    "metadata": {},
    "name": "TradeFavoritesProviderQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "91cf3f81a2ae4a3a5d284539f00f5e08";

export default node;
